export function contractBus(id) {
    return axios({
        url: `/api/test/insurance/bus/contract/create`,
        method: 'post',
        data: {
            orderId: id,
        },
    });
}
